import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ClerkProvider } from '@clerk/clerk-react';
import { I18nProvider } from '@lingui/react';
import { i18n } from '@lingui/core';
import App from './App';
import { defaultLocale, dynamicActivate } from './i18n';
import './index.css';

const PUBLISHABLE_KEY = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY;

if (!PUBLISHABLE_KEY) {
  throw new Error('Missing VITE_CLERK_PUBLISHABLE_KEY in .env');
}

// Activate the saved locale or default
const savedLocale = localStorage.getItem('locale') ?? defaultLocale;

void dynamicActivate(savedLocale).then(() => {
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <BrowserRouter>
        <ClerkProvider publishableKey={PUBLISHABLE_KEY} signInUrl="/sign-in" signUpUrl="/sign-up">
          <I18nProvider i18n={i18n}>
            <App />
          </I18nProvider>
        </ClerkProvider>
      </BrowserRouter>
    </React.StrictMode>,
  );
});
